import React from "react";
import ErrorBanner from "src/components/Form/ErrorBanner";
import ChangeRequestContext from "src/context/ChangeRequestContext";

export const AlertBannerSection = () => {
  const { displayingAlertBanner, setDisplayingAlertBanner } =
    React.useContext(ChangeRequestContext);

  return (
    <ErrorBanner
      errorType={displayingAlertBanner}
      onClose={setDisplayingAlertBanner}
      alertBannerProps={{
        fluidity: false,
      }}
    />
  );
};
